import axios from "@/api/axios";

const countVisits = (data) => {
    return axios
        .post('/admin/visits', {visits: data})
        .then(response => response.data)
}

export default {
    countVisits,
}